import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import * as c from "../constant";
import LocalPhoto from "app/modules/upload/LocalPhotoPub";
import LocalResume from "app/modules/upload/UploadResumePub";
import thumbnail from "assets/img/thumbnail.jpg";
import document from "assets/img/document.png";
import documentFiled from "assets/img/document-file.png";
import ApplicationTipsModal from "./ApplicationTipsModal";
import ContactRecruitmentModal from "./ContactRecruitmentModal";
import { _ } from "../../../Utils";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import alert from "react-s-alert";
import moment from "moment";

class JobSeeker extends Component {
  state = {
    yes: false,
    no: false,
    isPasswordVisible: false,
  };

  componentWillMount() {
    const { dispatch } = this.props;
    dispatch({
      type: c.GET_LINKS,
    });
    dispatch({
      type: c.GET_APPLICANT_SOURCE,
    });
    this.showInfo();
  }

  showInfo = (e) => {
    const { dispatch } = this.props;

    dispatch({
      type: "MODAL",
      data: {
        isOpen: true,
        title: "Important Points on Making a Good Resume",
        modalSize: "modal-lg",
        content: <ApplicationTipsModal />,
      },
    });
  };

  userExist = (args) => {
    const { dispatch } = this.props;

    dispatch({
      type: c.CLEAR_FORM_DATA,
    });

    dispatch({
      type: "MODAL",
      data: {
        isOpen: true,
        title: "Account Already Exists",
        modalSize: "modal-md",
        content: <ContactRecruitmentModal data={args} />,
      },
    });
  };

  handleChangeSelect = (key) => (value) => {
    const { dispatch } = this.props;
    dispatch({
      type: c.SET_FORM_DATA,
      data: {
        [key]: value || "",
      },
    });
  };

  checkUser = _.debounce((args) => {
    const { dispatch } = this.props;
    dispatch({
      type: c.GET_CHECK_USER,
      args,
      onSuccess: () => {
        this.userExist(args);
      },
    });
  }, 500);

  handleOnChange = (e) => {
    e.preventDefault();
    const { dispatch, form_data } = this.props;
    let { name, value } = e.target;
    if (name === "peos_certificate_id") {
      const max_chars = 30;
      if (value.length > max_chars) {
        value = value.substr(0, max_chars);
      }
    }
    dispatch({
      type: c.SET_FORM_DATA,
      data: {
        [name]: value,
      },
    });

    const formdata = form_data.toJS(); // const { form_data } = this.props;

    if (
      formdata.firstname &&
      formdata.lastname &&
      formdata.middlename &&
      formdata.birthdate &&
      _.includes(["firstname", "lastname", "middlename", "birthdate"], name)
    ) {
      const userdata = {
        firstname: formdata.firstname,
        lastname: formdata.lastname,
        middlename: formdata.middlename,
        birthdate: moment(formdata.birthdate).format("YYYY-MM-DD"),
        [name]: value,
      };

      this.checkUser(userdata);
    }
  };

  handleOnChangeDate = (key) => (value) => {
    const { dispatch, form_data } = this.props;
    dispatch({
      type: c.SET_FORM_DATA,
      data: {
        [key]: value,
      },
    });

    const formdata = form_data.toJS(); // const { form_data } = this.props;

    if (formdata.firstname && formdata.lastname && formdata.middlename) {
      const userdata = {
        firstname: formdata.firstname,
        lastname: formdata.lastname,
        middlename: formdata.middlename,
        birthdate: moment(value).format("YYYY-MM-DD"),
      };

      this.checkUser(userdata);
    }
  };

  uploadPhoto = (key) => (files) => {
    const { dispatch } = this.props;
    dispatch({
      type: c.SET_FORM_DATA,
      data: {
        [key]: files.upload_file,
      },
    });
  };

  handleOnSubmit = (e) => {
    e.preventDefault();
    const { dispatch, form_data } = this.props;
    if (form_data.get("evaluation_form") == "")
      return alert.error("Evaluation form is required");

    if (form_data.get("resumeuploaded") == "")
      return alert.error("Resume form is required");

    if (form_data.get("photo") == "") return alert.error("Photo is required");

    if (
      +form_data.get("is_nurse") === 1 &&
      form_data.get("self_assessment_form") === ""
    )
      return alert.error("Self Assessment form is required");

    if (form_data.get("is_nurse") === "")
      return alert.error("Are you a nurse option is required");

    dispatch({
      type: c.REGISTER,
      args: {
        ...form_data.toJS(),
        is_nurse: +form_data.get("is_nurse") ? 1 : 0,
        birthdate: format(form_data.get("birthdate"), "yyyy-MM-dd") || "",
      },
    });
  };

  togglePassword = (e) => {
    e.preventDefault();
    this.setState({
      isPasswordVisible: !this.state.isPasswordVisible,
    });
  };

  render() {
    const {
      form_data,
      categories,
      location,
      links,
      applicant_sources,
      isLoading,
    } = this.props;

    const civilstatus = [
      {
        label: "SINGLE",
        value: "SINGLE",
      },
      {
        label: "MARRIED",
        value: "MARRIED",
      },
      {
        label: "WIDOWED",
        value: "WIDOWED",
      },
      {
        label: "SINGLE PARENT",
        value: "SINGLE PARENT",
      },
      {
        label: "SEPARATED",
        value: "SEPARATED",
      },
      {
        label: "ANNULLED",
        value: "ANNULLED",
      },
      {
        label: "DIVORCED",
        value: "DIVORCED",
      },
    ];

    let days = [];
    for (let i = 1; i < 32; i++) {
      days.push({
        label: i,
        value: i,
      });
    }

    console.log(form_data.toJS());

    return (
      <insidepagecontent>
        <div className="page-content container-fluid ">
          <div className="inside-page-section _news-events container">
            <div className="section-title mb-5 mt-5">
              <h2 className="text-center">Registration</h2>
            </div>
            <div className="row p-3">
              <div className="col-12 p-3">
                <div className="card border-success mb-3 mt-2 ">
                  <div className="card-header bg-primary text-white">
                    <b>Requirements</b>
                  </div>
                  <div className="card-body">
                    <ul className="list-unstyled">
                      <li>
                        <ul className="bullet">
                          <li className="mb-3">
                            <a
                              href={links.getIn(["peos", "link"])}
                              target="_blank"
                              className="pb-0 mb-0"
                            >
                              {" "}
                              Mandatory Pre-Employment Orientation Seminar
                              (PEOS) online
                            </a>
                          </li>
                          <li className="mb-3">
                            <Link
                              to="/cabin-crew"
                              target="_blank"
                              className="pb-0 mb-0"
                            >
                              {" "}
                              Cabin Crew Applicant
                            </Link>
                          </li>
                          <li className="mb-3">
                            <Link
                              to="/healthcare"
                              target="_blank"
                              className="pb-0 mb-0"
                            >
                              {" "}
                              Healthcare Applicant
                            </Link>
                          </li>
                          {
                            // <li className="mb-3">
                            //   <Link
                            //     to="/emirates"
                            //     target="_blank"
                            //     className="pb-0 mb-0"
                            //   >
                            //     Emirates Group / DNATA Applicant
                            //   </Link>
                            // </li>
                          }
                          <li className="mb-3">
                            <Link
                              to="/faq"
                              target="_blank"
                              className="pb-0 mb-0"
                            >
                              All Other Jobs
                            </Link>
                          </li>
                          <li className="mb-3">
                            <Link
                              to="/faq"
                              target="_blank"
                              className="pb-0 mb-0"
                            >
                              Documents Required
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 pb-5">
                <form onSubmit={this.handleOnSubmit}>
                  <div className="row">
                    <div className="row col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                      <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 form-left-column ">
                        <div className="input-group mb-3 jobs-search-wrap row">
                          <div className="col-12 col-sm-6 col-md-12 col-lg-12 upload-input">
                            <div
                              className="img-thumbnail"
                              style={{ width: "100%", margin: "auto" }}
                            >
                              <img
                                src={
                                  form_data.get("photo")
                                    ? form_data.get("photo")
                                    : thumbnail
                                }
                                alt="..."
                                className="img-thumbnail float-left"
                              />
                              <LocalPhoto
                                crop={"400x400"}
                                label="Upload Photo"
                                className="btn btn-sm btn-primary col-12 "
                                icon={`fa fa-camera`}
                                onUploaded={this.uploadPhoto("photo")}
                              />
                              <i className="ml-1 font-italic font-weight-bold text-danger">
                                (1MB, JPG or PNG)
                              </i>
                            </div>
                          </div>
                          <div className="col-12 col-sm-6 col-md-12 col-lg-12 upload-input">
                            <div
                              className="img-thumbnail"
                              style={{ width: "100%", margin: "auto" }}
                            >
                              {form_data.get("resumeuploaded") ? (
                                <div className="text-center">
                                 <small className="text-bold mx-auto">Click to View</small>
                                  <a
                                    href={form_data.get("resumeuploaded")}
                                    target="_blank"
                                  >
                                    <img
                                      src={documentFiled}
                                      alt="..."
                                      className="img-thumbnail float-left"
                                    />
                                  </a>
                                </div>
                              ) : (
                                <img
                                  src={document}
                                  alt="..."
                                  className="img-thumbnail float-left"
                                />
                              )

                              }
                              <LocalResume
                                crop={"400x400"}
                                label={`${
                                  form_data.get("resumeuploaded") === ""
                                    ? "Upload Resume"
                                    : "Re-Upload Resume"
                                }`}
                                className="btn btn-sm btn-primary col-md-12 "
                                icon={`fa fa-camera`}
                                onUploaded={this.uploadPhoto("resumeuploaded")}
                              />

                              <i className="ml-1 font-italic font-weight-bold text-danger">
                                (3MB, DOC/X or PDF)
                              </i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 form-right-column">
                        <div className="row">
                          <div className="input-group mb-3 jobs-search-wrap col-md-6 col-lg-6 col-6 p-0">
                            <label className="col-12 col-form-label">
                              Position Applied
                            </label>
                            <div className="col-12">
                              <input
                                type="text"
                                name="position1"
                                className="form-control"
                                value={form_data.get("position1")}
                                onChange={this.handleOnChange}
                              />
                            </div>
                          </div>

                          <div className="input-group mb-3 jobs-search-wrap col-md-6 col-lg-6 col-6 p-0">
                            <label className="col-12 col-form-label">
                              <i className="text-danger">* </i> Application
                              Source
                            </label>
                            <div className="col-12">
                              <Select
                                className=""
                                value={form_data.get("source")}
                                simpleValue
                                onChange={this.handleChangeSelect("source")}
                                name="source"
                                loadingPlaceholder="Loading..."
                                isLoading={isLoading}
                                options={applicant_sources
                                  .toJS()
                                  .map((item) => ({
                                    label: item.source_name,
                                    value: item.source_name,
                                  }))}
                                placeholder="Select"
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="input-group mb-3 jobs-search-wrap col-md-12 col-lg-12 col-12 p-0">
                            <label className="col-12 col-form-label ">
                              <i className="text-danger">* </i>PEOS Certificate
                              ID (
                              <a
                                href={links.getIn(["peos", "link"])}
                                target="_blank"
                                className="text-primary"
                              >
                                Get PEOS ID here
                              </a>
                              )
                            </label>
                            <div className="col-12">
                              <input
                                type="text"
                                maxLength="30"
                                name="peos_certificate_id"
                                className="form-control"
                                value={form_data.get("peos_certificate_id")}
                                onChange={this.handleOnChange}
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="input-group mb-3 jobs-search-wrap col-md-6 col-lg-6 col-12 p-0">
                            <label className="col-12 col-form-label">
                              <i className="text-danger">* </i>First Name
                            </label>
                            <div className="col-12">
                              <input
                                type="text"
                                name="firstname"
                                className="form-control"
                                value={form_data.get("firstname")}
                                onChange={this.handleOnChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="input-group mb-3 jobs-search-wrap col-md-6 col-lg-6 col-12 p-0">
                            <label className="col-12 col-form-label">
                              <i className="text-danger">* </i>Middle Name
                            </label>
                            <div className="col-12">
                              <input
                                type="text"
                                name="middlename"
                                className="form-control"
                                value={form_data.get("middlename")}
                                onChange={this.handleOnChange}
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="input-group mb-3 jobs-search-wrap col p-0">
                            <label className="col-12 col-form-label">
                              <i className="text-danger">* </i>Last Name
                            </label>
                            <div className="col-12">
                              <input
                                type="text"
                                name="lastname"
                                className="form-control"
                                value={form_data.get("lastname")}
                                onChange={this.handleOnChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="input-group mb-3 jobs-search-wrap col p-0">
                            <label className="col-12 col-form-label">
                              Suffix
                            </label>
                            <div className="col-12">
                              <input
                                type="text"
                                name="suffix"
                                className="form-control"
                                value={form_data.get("suffix")}
                                onChange={this.handleOnChange}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="input-group mb-3 jobs-search-wrap col p-0">
                            <label className="col-12 col-form-label">
                              Present Address
                            </label>
                            <div className="col-12">
                              <input
                                type="text"
                                name="address"
                                className="form-control"
                                value={form_data.get("address")}
                                onChange={this.handleOnChange}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="input-group mb-3 jobs-search-wrap col-md-6 col-lg-6 col-12 p-0">
                            <label className="col-12 col-form-label">
                              <i className="text-danger">* </i>Current Location
                            </label>
                            <div className="col-12">
                              <Select
                                className=""
                                value={form_data.get("location")}
                                simpleValue
                                onChange={this.handleChangeSelect("location")}
                                name="location"
                                loadingPlaceholder="Loading..."
                                options={location.toJS().map((item) => {
                                  return {
                                    label: item.name,
                                    value: item.name,
                                  };
                                })}
                                required
                              />
                            </div>
                          </div>
                          <div className="input-group mb-3 jobs-search-wrap col-md-6 col-lg-6 col-12 p-0">
                            <label className="col-12 col-form-label">
                              <i className="text-danger">* </i>Email
                            </label>
                            <div className="col-12">
                              <input
                                type="email"
                                name="email"
                                className="form-control"
                                value={form_data.get("email")}
                                onChange={this.handleOnChange}
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="input-group mb-3 jobs-search-wrap col-md-6 col-lg-6 col-12 p-0">
                            <label className="col-12 col-form-label">
                              <i className="text-danger">* </i>Password (min 8
                              characters)
                            </label>
                            <div className="col-12">
                              <input
                                type={
                                  this.state.isPasswordVisible
                                    ? "text"
                                    : "password"
                                }
                                name="password2"
                                className="form-control"
                                value={form_data.get("password2")}
                                onChange={this.handleOnChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="input-group mb-3 jobs-search-wrap col-md-6 col-lg-6 col-12 p-0">
                            <label className="col-12 col-form-label">
                              <i className="text-danger">* </i>Confirm Password
                            </label>
                            <div className="col-12">
                              <div className="input-group">
                                <input
                                  type={
                                    this.state.isPasswordVisible
                                      ? "text"
                                      : "password"
                                  }
                                  name="password_confirmation"
                                  className="form-control"
                                  value={form_data.get("password_confirmation")}
                                  onChange={this.handleOnChange}
                                  required
                                />
                                <div className="input-group-append ">
                                  <span
                                    className="input-group-text bg-light text-primary"
                                    id="basic-addon2"
                                    onClick={this.togglePassword}
                                  >
                                    <i
                                      className={`fas fa-eye${
                                        this.isPasswordVisible ? "-slash" : ""
                                      }`}
                                    ></i>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="input-group mb-3 jobs-search-wrap col-4 p-0">
                            <label className="col-12 col-form-label">
                              <i className="text-danger">* </i>Birthdate
                            </label>
                            <div className="col-12">
                              <DatePicker
                                required
                                selected={form_data.get("birthdate")}
                                name="birthdate"
                                onChange={this.handleOnChangeDate("birthdate")}
                                dateFormat="MM-dd-yyyy"
                                className="form-control"
                                autoComplete="off"
                              />
                            </div>
                          </div>
                          <div className="input-group mb-3 jobs-search-wrap col-md-4 col-lg-4 col-12 p-0">
                            <label className="col-12 col-form-label">
                              <i className="text-danger">* </i>Gender
                            </label>
                            <div className="col-12">
                              <Select
                                className=""
                                value={form_data.get("gender")}
                                simpleValue
                                onChange={this.handleChangeSelect("gender")}
                                name="gender"
                                loadingPlaceholder="Loading..."
                                options={[
                                  {
                                    label: "MALE",
                                    value: "MALE",
                                  },
                                  {
                                    label: "FEMALE",
                                    value: "FEMALE",
                                  },
                                ]}
                                placeholder="Select"
                                required
                              />
                            </div>
                          </div>
                          <div className="input-group mb-3 jobs-search-wrap col-md-4 col-lg-4 col-12 p-0">
                            <label className="col-12 col-form-label">
                              <i className="text-danger">* </i>Civil Status
                            </label>
                            <div className="col-12">
                              <Select
                                className=""
                                value={form_data.get("civilstatus")}
                                simpleValue
                                onChange={this.handleChangeSelect(
                                  "civilstatus"
                                )}
                                name="civilstatus"
                                loadingPlaceholder="Loading..."
                                options={civilstatus}
                                placeholder="Select"
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="input-group mb-3 jobs-search-wrap col-md-6 col-lg-6 col-12 p-0">
                            <div className="col pb-2">
                              <label className="col-12 col-form-label">
                                <i className="text-danger">* </i>Height (cm)
                              </label>
                              <input
                                type="number"
                                name="height"
                                className="form-control"
                                value={form_data.get("height")}
                                onChange={this.handleOnChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="input-group mb-3 jobs-search-wrap col-md-6 col-lg-6 col-12 p-0">
                            <div className="col pb-2">
                              <label className=" col-form-label">
                                <i className="text-danger">* </i>Weight (kg)
                              </label>
                              <input
                                type="number"
                                name="weight"
                                className="form-control"
                                value={form_data.get("weight")}
                                onChange={this.handleOnChange}
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="input-group mb-3 jobs-search-wrap col-md-6 col-lg-6 col-12 p-0">
                            <label className="col-12 col-form-label">
                              <i className="text-danger">* </i>Nationality
                            </label>
                            <div className="col-12">
                              <Select
                                className=""
                                value={form_data.get("nationality")}
                                simpleValue
                                onChange={this.handleChangeSelect(
                                  "nationality"
                                )}
                                name="nationality"
                                loadingPlaceholder="Loading..."
                                options={[
                                  {
                                    label: "FILIPINO",
                                    value: "FILIPINO",
                                  },
                                  {
                                    label: "FOREIGNER",
                                    value: "FOREIGNER",
                                  },
                                ]}
                                placeholder="Select"
                                required
                              />
                            </div>
                          </div>
                          <div className="input-group mb-3 jobs-search-wrap col-md-6 col-lg-6 col-12 p-0">
                            <label className="col-12 col-form-label">
                              <i className="text-danger">* </i>Religion
                            </label>
                            <div className="col-12">
                              <Select
                                className=""
                                value={form_data.get("religion")}
                                simpleValue
                                onChange={this.handleChangeSelect("religion")}
                                name="religion"
                                loadingPlaceholder="Loading..."
                                options={[
                                  {
                                    label: "Catholic",
                                    value: "CATHOLIC",
                                  },
                                  {
                                    label: "Christian",
                                    value: "CHRISTIAN",
                                  },
                                  {
                                    label: "Muslim",
                                    value: "MUSLIM",
                                  },
                                  {
                                    label: "Born Again",
                                    value: "BORN AGAIN",
                                  },
                                  {
                                    label: "Protestant",
                                    value: "PROTESTANT",
                                  },
                                  {
                                    label: "Evangelical",
                                    value: "EVANGELICAL",
                                  },
                                  {
                                    label: "Iglesia Ni Cristo",
                                    value: "IGLESIA NI CRISTO",
                                  },
                                  {
                                    label: "Seventh-Day Adventist",
                                    value: "SEVENTH-DAY ADVENTIST",
                                  },
                                  {
                                    label: "Others",
                                    value: "OTHERS",
                                  },
                                ]}
                                placeholder="Select"
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="input-group mb-3 jobs-search-wrap col-md-6 col-lg-6 col-12 p-0">
                            <label className="col-12 col-form-label">
                              <i className="text-danger">* </i>Mobile Number
                            </label>
                            <div className="col-12">
                              <input
                                type="text"
                                name="mobile"
                                className="form-control"
                                value={form_data.get("mobile")}
                                onChange={this.handleOnChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="input-group mb-3 jobs-search-wrap col-md-6 col-lg-6 col-12 p-0">
                            <label className="col-12 col-form-label">
                              Other Contact Number
                            </label>
                            <div className="col-12">
                              <input
                                type="text"
                                name="mobile2"
                                className="form-control"
                                value={form_data.get("mobile2")}
                                onChange={this.handleOnChange}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="input-group mb-3 jobs-search-wrap col-md-6 col-lg-6 col-12 p-0">
                            <label className="col-12 col-form-label">
                              <i className="text-danger">* </i> Years of
                              Relevant Experience
                            </label>
                            <div className="col-12">
                              <input
                                type="number"
                                name="yearsofexp"
                                className="form-control"
                                value={form_data.get("yearsofexp")}
                                onChange={this.handleOnChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="input-group mb-3 jobs-search-wrap col-md-6 col-lg-6 col-12 p-0">
                            <label className="col-12 col-form-label">
                              <i className="text-danger">* </i>Availability
                            </label>
                            <div className="col-12">
                              <Select
                                className=""
                                value={form_data.get("availability")}
                                simpleValue
                                onChange={this.handleChangeSelect(
                                  "availability"
                                )}
                                name="availability"
                                loadingPlaceholder="Loading..."
                                options={[
                                  {
                                    label: "AS SOON AS POSSIBLE",
                                    value: "AS SOON AS POSSIBLE",
                                  },
                                  {
                                    label: "After 1 Month",
                                    value: "After 1 Month",
                                  },
                                  {
                                    label: "After 3 Months",
                                    value: "After 3 Months",
                                  },
                                  {
                                    label: "Need to confirm",
                                    value: "Need to confirm",
                                  },
                                ]}
                                placeholder="Select"
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="input-group mb-3 jobs-search-wrap col-md-12 col-lg-12 col-12 p-0">
                            <label className="col-12 col-form-label">
                              Specify any physical deformity, disability, or
                              defect:
                            </label>
                            <div className="col-12">
                              <input
                                type="text"
                                name="defect"
                                className="form-control"
                                value={form_data.get("defect")}
                                onChange={this.handleOnChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="input-group mb-3 jobs-search-wrap col-12 p-0">
                            <label className="col-12 col-form-label">
                              <i className="text-danger">* </i>Job Category 1
                            </label>
                            <div className="col-12">
                              <Select
                                className=""
                                value={form_data.get("jobcat1")}
                                simpleValue
                                onChange={this.handleChangeSelect("jobcat1")}
                                name="jobcat1"
                                loadingPlaceholder="Loading..."
                                options={categories.toJS().map((item) => {
                                  return {
                                    label: item.name,
                                    value: item.id,
                                  };
                                })}
                                placeholder="Select"
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="input-group mb-3 jobs-search-wrap col-12 p-0">
                            <label className="col-12 col-form-label">
                              <i className="text-danger">* </i>Job Category 2
                            </label>
                            <div className="col-12">
                              <Select
                                className=""
                                value={form_data.get("jobcat2")}
                                simpleValue
                                onChange={this.handleChangeSelect("jobcat2")}
                                name="jobcat2"
                                loadingPlaceholder="Loading..."
                                options={categories.toJS().map((item) => {
                                  return {
                                    label: item.name,
                                    value: item.id,
                                  };
                                })}
                                placeholder="Select"
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="input-group mb-3 jobs-search-wrap col-12 p-0">
                            <label className="col-12 col-form-label">
                              <i className="text-danger">* </i>Job Category 3
                            </label>
                            <div className="col-12">
                              <Select
                                className=""
                                value={form_data.get("jobcat3")}
                                simpleValue
                                onChange={this.handleChangeSelect("jobcat3")}
                                name="jobcat3"
                                loadingPlaceholder="Loading..."
                                options={categories.toJS().map((item) => {
                                  return {
                                    label: item.name,
                                    value: item.id,
                                  };
                                })}
                                placeholder="Select"
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <p>
                              <i className="text-danger">* </i>Please download
                              and fill out the appropriate evaluation form
                              according to your preferred position:
                            </p>
                            <ul className="registration">
                              <li>
                                <a
                                  target="_blank"
                                  href={links.getIn(["gef", "link"])}
                                  className="text-primary"
                                >
                                  General Evaluation Form
                                </a>{" "}
                                - for technical, skilled, customer service,
                                administrative and other professional positions
                              </li>
                              <li>
                                <a
                                  target="_blank"
                                  className="text-primary"
                                  href={links.getIn(["hmsef", "link"])}
                                >
                                  Healthcare and Medical Services Evaluation
                                  Form
                                </a>{" "}
                                - for healthcare and other medical services
                                positions
                              </li>
                              <li>
                                <a
                                  target="_blank"
                                  className="text-primary"
                                  href={links.getIn(["rnssf", "link"])}
                                >
                                  {" "}
                                  Registered Nurse Skill Self Assessment Form
                                </a>{" "}
                                - if you are a nurse, please fill out this form
                                also aside from the Healthcare and Medical
                                Services Evaluation Form
                              </li>
                              <li>
                                <a
                                  target="_blank"
                                  className="text-primary"
                                  href={links.getIn(["ccef", "link"])}
                                >
                                  Cabin Crew Evaluation Form
                                </a>{" "}
                                - for cabin crew/flight attendant positions
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-12 mt-5 p-0">
                            <div className="row">
                              <div className="col-md-6">
                                <p>
                                  <i className="text-danger">* </i> Upload your
                                  preferred filled out Evaluation Form here
                                </p>
                              </div>
                              <div className="col">
                                <LocalResume
                                  crop={"400x400"}
                                  label={`${
                                    form_data.get("evaluation_form") === ""
                                      ? "UPLOAD EVALUATION FORM HERE"
                                      : "UPDATE EVALUATION FORM HERE"
                                  }`}
                                  className="btn btn-sm btn-primary col-md-12 "
                                  icon={`fa fa-camera`}
                                  onUploaded={this.uploadPhoto(
                                    "evaluation_form"
                                  )}
                                />
                              </div>
                              {form_data.get("evaluation_form") && (
                                <div className="col-md-1">
                                  <a
                                    href={form_data.get("evaluation_form")}
                                    target="_blank"
                                    className="btn btn-primary btn-sm"
                                  >
                                    <i className="fas fa-file" />
                                  </a>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-md-12 mt-5 p-0">
                            <div className="row">
                              <div className="col-md-6">
                                <i className="text-danger">* </i> Are you a
                                nurse?
                                <div className="custom-control custom-radio custom-control-inline ml-2">
                                  <input
                                    type="radio"
                                    id="customRadioInline1"
                                    name="is_nurse"
                                    className="custom-control-input"
                                    value="yes"
                                    onChange={() => {
                                      const { dispatch } = this.props;
                                      this.setState({
                                        yes: true,
                                        no: false,
                                        is_nurse: "yes",
                                      });
                                      dispatch({
                                        type: c.SET_FORM_DATA,
                                        data: {
                                          is_nurse: "1",
                                        },
                                      });
                                    }}
                                    required
                                    checked={this.state.yes}
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="customRadioInline1"
                                  >
                                    Yes
                                  </label>
                                </div>
                                <div className="custom-control custom-radio custom-control-inline">
                                  <input
                                    type="radio"
                                    id="customRadioInline2"
                                    name="is_nurse"
                                    className="custom-control-input"
                                    value="no"
                                    onChange={() => {
                                      const { dispatch } = this.props;
                                      this.setState({
                                        no: true,
                                        yes: false,
                                        is_nurse: "no",
                                      });
                                      dispatch({
                                        type: c.SET_FORM_DATA,
                                        data: {
                                          is_nurse: "0",
                                        },
                                      });
                                    }}
                                    checked={this.state.no}
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="customRadioInline2"
                                  >
                                    No
                                  </label>
                                </div>
                                <p className="mt-0">
                                  Upload your RN Skill Self Assessment Form here
                                  if yes
                                </p>
                              </div>
                              <div className="col">
                                <LocalResume
                                  crop={"400x400"}
                                  label={`${
                                    form_data.get("self_assessment_form") === ""
                                      ? "UPLOAD RN SELF ASSESSMENT FORM HERE"
                                      : "UPDATE RN SELF ASSESSMENT FORM HERE"
                                  }`}
                                  className={`btn btn-sm btn-primary col-md-12 ${
                                    this.state.is_nurse === "yes"
                                      ? ""
                                      : "disabled"
                                  }`}
                                  icon={`fa fa-camera`}
                                  onUploaded={this.uploadPhoto(
                                    "self_assessment_form"
                                  )}
                                  disable
                                />
                              </div>
                              {form_data.get("self_assessment_form") && (
                                <div className="col-md-1">
                                  <a
                                    href={form_data.get("self_assessment_form")}
                                    target="_blank"
                                    className="btn btn-primary btn-sm"
                                  >
                                    <i className="fas fa-file" />
                                  </a>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row pt-3 footer-clearance">
                          <div className="input-group mb-3 jobs-search-wrap col-12 p-0">
                            <div className="col-12">
                              <button
                                type="submit"
                                className="btn btn-block btn-lg btn-primary"
                                disabled={this.props.isLoading}
                              >
                                {this.props.isLoading && (
                                  <h3 className="float-left">
                                    <i class="fa fa-spinner fa-pulse h6" />
                                  </h3>
                                )}
                                Register
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </insidepagecontent>
    );
  }
}

const mapStateToProps = (state, routeParams) => {
  const { loadingTypes } = state.loading;
  const form_data = state.auth.get("form_data");
  const categories = state.auth.get("categories");
  const location = state.auth.get("location");
  const links = state.auth.get("links");
  const applicant_sources = state.auth.get("applicant_sources");
  console.log(state.loading);
  return {
    isLoading: loadingTypes.length > 0,
    form_data,
    categories,
    location,
    links,
    applicant_sources,
  };
};

export default withRouter(connect(mapStateToProps)(JobSeeker));
